import { useAttributesContext } from "shared/contexts/AttributesContext";
import { ContextProviderName } from "shared/contexts/types";
import { DEALERS_GENERIC_FILTER } from "shared/filterDefinitions";

import { UseSchema } from "./types";
import { getGroupBySelectOptions } from "./utils/group-by-utils";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

const VALUES_ENDPOINT = "dealers";

const useDealersSchema = (): UseSchema => {
  const { attributes } = useAttributesContext(ContextProviderName.Dealer);

  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    DEALERS_GENERIC_FILTER,
    attributeMap,
    VALUES_ENDPOINT
  );

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const schema = getSchemaFromAttributes(attributes, getSchemaEntry);

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  const groupBySelectOptions = getGroupBySelectOptions(attributes);

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    attributes,
    groupBySelectOptions,
    getSchemaEntry,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
    getSchemaForAccessor,
  };
};
export default useDealersSchema;
